import React from 'react';
import { VStack, Wrap } from '@chakra-ui/react';
import BarChart from 'components/Charts/BarChart';
import LineChart from 'components/Charts/LineChart';
import MultiChart from 'components/Charts/MultiChart';
import {
  barDataWithBorderColorAndColorArray,
  barDataWithColorArray,
  barDataWithDefaultColors,
  barDataWithDefaultColorsAndTwoDatasets,
  barDataWithOneColor,
  lineDataWithBorderColorAndColorArray,
  lineDataWithBorderColorAndTwoDatasets,
  lineDataWithColorArray,
  lineDataWithDefaultColors,
  lineDataWithOneColor,
  multiChartDefaultColorsBars,
  multiChartDefaultColorsLinesAndBars,
  multiChartWithColorsBarsAndLinesAndBorderColors,
  multiChartWithColorsBarsStackedAndLines,
  testLabels,
} from 'utils/constants';

export const ChartsExamples: React.FC = () => {
  return (
    <VStack>
      <Wrap justify="center">
        <MultiChart
          labels={testLabels}
          data={multiChartDefaultColorsLinesAndBars}
          type="bar"
        />
        <MultiChart
          labels={testLabels}
          data={multiChartDefaultColorsLinesAndBars}
          type="line"
        />
        <MultiChart
          labels={testLabels}
          data={multiChartDefaultColorsBars}
          type="bar"
        />
        <MultiChart
          labels={testLabels}
          options={{
            scales: { x: { stacked: true, grid: { display: false } } },
          }}
          data={multiChartWithColorsBarsStackedAndLines}
          type="line"
        />
        <MultiChart
          labels={testLabels}
          options={{
            scales: { x: { grid: { display: false } } },
          }}
          data={multiChartWithColorsBarsAndLinesAndBorderColors}
          type="line"
        />
      </Wrap>
      <Wrap justify="center">
        <LineChart labels={testLabels} data={lineDataWithDefaultColors} />
        <LineChart labels={testLabels} data={lineDataWithColorArray} />
        <LineChart
          fill={false}
          labels={testLabels}
          data={lineDataWithDefaultColors}
        />
        <LineChart
          fill={false}
          labels={testLabels}
          data={lineDataWithBorderColorAndTwoDatasets}
        />
        <LineChart labels={testLabels} data={lineDataWithOneColor} />
        <LineChart
          labels={testLabels}
          data={lineDataWithBorderColorAndColorArray}
        />
      </Wrap>
      <Wrap justify="center">
        <BarChart labels={testLabels} data={barDataWithDefaultColors} />
        <BarChart
          labels={testLabels}
          data={barDataWithDefaultColorsAndTwoDatasets}
        />
        <BarChart
          labels={testLabels}
          stackedX={true}
          data={barDataWithDefaultColorsAndTwoDatasets}
        />
        <BarChart labels={testLabels} data={barDataWithColorArray} />
        <BarChart labels={testLabels} data={barDataWithOneColor} />
        <BarChart
          labels={testLabels}
          data={barDataWithBorderColorAndColorArray}
        />
      </Wrap>
    </VStack>
  );
};
